import { MenuItem } from "../models/menu-item.model";

export const MAIN_MENU: Array<MenuItem> = [
    {
        // icon: '',
        link: '/',
        title: 'Inicio',
        class: '',
        href: false,
        slideMenu: true
    },
    {
        // icon: '',
        link: '/insights',
        title: 'Medidores',
        class: '',
        href: false,
        slideMenu: true
    },

]